import { Interface } from '@ethersproject/abi'
import IDO_ABI  from './ido.json'

const IDO_ABI_INTERFACE = new Interface(IDO_ABI)

export { IDO_ABI_INTERFACE }
